import React from "react";
import PropTypes from "prop-types";

function normalizeBounds(bounds = {}) {
  const left = Number(bounds.left || 0);
  const top = Number(bounds.top || 0);
  const width = Math.max(
    0,
    Number(
      bounds.width ??
        Number(bounds.right || 0) - left
    ) || 0
  );
  const height = Math.max(
    0,
    Number(
      bounds.height ??
        Number(bounds.bottom || 0) - top
    ) || 0
  );

  return {
    left,
    top,
    width,
    height,
  };
}

export default function StudioSelectionOverlay({
  bounds = null,
  visible = true,
  children = null,
  className = "",
  testId = "studio-selection-overlay",
}) {
  if (!visible || !bounds) {
    return null;
  }

  const normalizedBounds =
    normalizeBounds(bounds);

  return (
    <div
      className={[
        "studio-framework-selection-overlay",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      data-testid={testId}
      style={{
        left: normalizedBounds.left,
        top: normalizedBounds.top,
        width: normalizedBounds.width,
        height: normalizedBounds.height,
      }}
    >
      {children}
    </div>
  );
}

StudioSelectionOverlay.propTypes = {
  bounds: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    centerX: PropTypes.number,
    centerY: PropTypes.number,
  }),
  visible: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  testId: PropTypes.string,
};
